import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import React from "react";
import { useFormContext } from "react-hook-form";
import { ROLES_OPTIONS } from "../utils/helpers";

interface UserFormProps {
  mode: MODES_OPTIONS;
}

const UserForm = ({ mode }: UserFormProps) => {
  const form = useFormContext();
  const isView = mode === MODES_OPTIONS.VIEW;
  const isNew = mode === MODES_OPTIONS.NEW;

  return (
    <ResponsiveFormContainer columns={2}>
      <MTextField
        key={JSON.stringify(form.getValues("name"))}
        name="name"
        label="Nombre"
        type="text"
        fullWidth
        validation={{ required: "El nombre es requerido" }}
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("last_name"))}
        name="last_name"
        label="Apellido"
        type="text"
        fullWidth
        validation={{ required: "El apellido es requerido" }}
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("email"))}
        name="email"
        label="Email"
        type="email"
        fullWidth
        validation={{ required: "El email es requerido" }}
        disabled={isView}
      />
      <MAutocomplete
        key={JSON.stringify(form.getValues("roles"))}
        name="roles"
        options={ROLES_OPTIONS}
        label="Roles"
        multiple
        getOptionLabel={(option) => option || ""}
        validation={{ required: "Al menos un rol es requerido" }}
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("username"))}
        name="username"
        label="Username"
        type="text"
        fullWidth
        validation={{ required: "El usuario es requerido" }}
        disabled={isView}
      />
      {isNew && (
        <MTextField
          key={JSON.stringify(form.getValues("password"))}
          name="password"
          label="Contraseña"
          type={"password"}
          fullWidth
          validation={{ required: "La contraseña es requerida" }}
          disabled={isView}
        />
      )}
      <MTextField
        key={JSON.stringify(form.getValues("mobile_phone"))}
        name="mobile_phone"
        label="Teléfono móvil"
        type="text"
        fullWidth
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("phone"))}
        name="phone"
        label="Teléfono"
        type="text"
        fullWidth
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("address"))}
        name="address"
        label="Dirección"
        type="text"
        fullWidth
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("country"))}
        name="country"
        label="País"
        type="text"
        fullWidth
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("province"))}
        name="province"
        label="Provincia"
        type="text"
        fullWidth
        disabled={isView}
      />

      <MTextField
        key={JSON.stringify(form.getValues("city"))}
        name="city"
        label="Ciudad"
        type="text"
        fullWidth
        disabled={isView}
      />

      <MTextField
        key={JSON.stringify(form.getValues("postal_code"))}
        name="postal_code"
        label="Código postal"
        type="number"
        fullWidth
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("dni"))}
        name="dni"
        label="DNI"
        type="text"
        fullWidth
        disabled={isView}
      />
      <MTextField
        key={JSON.stringify(form.getValues("workstation"))}
        name="workstation"
        label="Cargo"
        type="text"
        fullWidth
        disabled={isView}
      />
    </ResponsiveFormContainer>
  );
};

export default UserForm;
